<template>
    <v-card>
        <v-card-title>
            <h3 class="text-h5 mb-0">New Dealer</h3>
        </v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field v-model="name" :rules="vruleFieldRequired" label="Name" required></v-text-field>
              <v-text-field v-model="dms_key" :rules="vruleFieldRequired" label="Dms Key" required></v-text-field>
              <v-text-field v-model="short_code" label="Short Code"></v-text-field>
              <v-btn color="primary" @click="validateAndSubmit">Save</v-btn>
              <v-btn @click="$emit('on-close')">Cancel</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import { mapActions } from 'vuex'

export default {
  name: 'dealer-create-card',
  mixins: [validationMixin],
  data () {
    return {
      valid: true,
      name: '',
      dms_key: '',
      short_code: ''
    }
  },
  methods: {
    ...mapActions('DealerStore', ['createDealer']),
    validateAndSubmit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.createDealer({
            name: this.name,
            dms_key: this.dms_key,
            short_code: this.short_code
          }).then(dealer => {
            this.$emit('on-create', dealer)
          }).catch(error => {
            this.$logger.trace(error)
            this.$flash({
              showClose: true,
              message: 'Error Saving Dealer. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
        }
      })
    }
  }
}
</script>
